import { z } from 'zod';
export const insuranceClaimsCustomerPortalIntakeAcceptanceCapability = 'insurance-claims.customer-portal-intake-acceptance.v1';
export const insuranceClaimsCustomerPortalIntakeAcceptanceSlot = 'customer-portal.project-intake-acceptance-actions';
export const insuranceClaimsCustomerPortalIntakeAcceptanceProviderId = 'insurance-claims.server.customer-portal-intake-acceptance';
const nullableText = (maximum) => z.string().trim().min(1).max(maximum).nullable();
export const insuranceClaimsCustomerPortalIntakeAcceptanceRequestSchema = z.strictObject({
    consumerModuleId: z.literal('customer-portal'),
    requestedCapability: z.literal(insuranceClaimsCustomerPortalIntakeAcceptanceCapability),
    sourceCapability: z.literal('customer-portal.project-intake-requests.v1'),
    commandId: z.string().uuid(),
    projectId: z.string().uuid(),
    intakeRequestId: z.string().uuid(),
    submissionId: z.string().uuid(),
    submissionRevision: z.number().int().positive(),
    submissionHash: z.string().regex(/^[a-f0-9]{64}$/),
    insurance: z.strictObject({
        insuranceCompany: nullableText(200),
        policyNumber: nullableText(120),
        claimNumber: nullableText(120),
        adjusterName: nullableText(200),
        adjusterEmail: z.string().trim().email().max(320).nullable(),
        adjusterPhone: nullableText(50),
    }),
});
export const insuranceClaimsCustomerPortalIntakeAcceptanceResponseSchema = z.strictObject({
    state: z.literal('accepted'),
    capability: z.literal(insuranceClaimsCustomerPortalIntakeAcceptanceCapability),
    tenantId: z.string().uuid(),
    projectId: z.string().uuid(),
    intakeRequestId: z.string().uuid(),
    factId: z.string().uuid(),
    idempotent: z.boolean(),
});
//# sourceMappingURL=insurance-claims-customer-portal-intake.contract.js.map